import React from 'react';
import { cn } from '@/lib/utils';
import { BaseTooltip } from '../Tooltip';

export interface ActionIconProps {
  icon: React.ReactNode;
  variant?: 'minimal' | 'badge';
  badgePosition?: 'top-right' | 'bottom-left';
  count?: number;
  onClick?: (e: React.MouseEvent) => void;
  tooltip?: string;
  className?: string;
  iconClassName?: string;
  badgeClassName?: string;
  disabled?: boolean;
}

export const ActionIcon: React.FC<ActionIconProps> = ({
  icon,
  variant = 'minimal',
  badgePosition = 'bottom-left',
  count,
  onClick,
  tooltip,
  className,
  iconClassName,
  badgeClassName,
  disabled = false,
}) => {
  const badgePositionClasses = {
    'top-right': '-top-0.5 -right-0.5',
    'bottom-left': '-bottom-0.5 -left-0.5',
  };

  const content = (
    <div
      className={cn(
        'relative cursor-pointer transition-opacity',
        disabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-70',
        className
      )}
      onClick={(e) => {
        if (!disabled && onClick) {
          e.stopPropagation();
          onClick(e);
        }
      }}
    >
      <div className={cn('h-4 w-4 flex items-center justify-center', iconClassName)}>{icon}</div>
      {variant === 'badge' && count !== undefined && count > 1 && (
        <span
          className={cn(
            'absolute h-2 w-2 rounded-full text-[6px] font-semibold text-white flex items-center justify-center',
            badgePositionClasses[badgePosition],
            badgeClassName
          )}
        >
          {count}
        </span>
      )}
    </div>
  );

  if (tooltip) {
    return <BaseTooltip content={tooltip}>{content}</BaseTooltip>;
  }

  return content;
};
